import { IsNumber } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class DepartmentDto extends BaseDto {
  id: number;
  name: string;
  merchantGroup: MerchantGroupDto;
  @IsNumber()
  merchantGroupId: number;
  createdDate: Date;
  enabled?: boolean;
}